import { createBasePlugin } from 'wix-rich-content-plugin-commons';
import { getBlockAtStartOfSelection, getDefaultKeyBinding } from 'wix-rich-content-editor-common';
import { LINK_PREVIEW_TYPE } from './types.js';
import LinkPreviewComponent from './LinkPreviewComponent.js';
import createToolbar from './toolbar/createToolbar.js';
import { c as convertLinkPreviewToLink } from './utils-c4245f57.js';
import { REMOVE_LINK_PREVIEW } from './consts.js';
import { DEFAULTS } from './defaults.js';
import 'react';
import './LinkPreviewViewer.js';
import 'lodash';
import 'wix-rich-content-common';
import 'wix-rich-content-common/dist/statics/schemas/plugin-link-preview.schema.json';
import './link-preview-d16f9cc2.js';
import 'wix-rich-content-plugin-html/libs/HtmlComponent';
import './toolbar/inline-buttons.js';
import './icons/ConvertToLinkIcon.js';
import './toolbar/insert-buttons.js';
import './toolbar/embedURLInputModal.js';
import 'prop-types';
import './toolbar/SocialEmbedInsertModal.js';
import 'wix-rich-content-ui-components';
import './icons/InstagramIcon.js';
import './icons/TwitterIcon.js';
import './icons/FacebookIcon.js';
import './icons/TikTokIcon.js';
import './icons/PinterestIcon.js';
import './icons/YoutubeIcon.js';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createLinkPreviewPlugin = (config) => {
  const type = LINK_PREVIEW_TYPE;
  if (!config[LINK_PREVIEW_TYPE]) {
    config[LINK_PREVIEW_TYPE] = {};
  }
  const _a = config, {
    [type]: settings = {},
    setEditorState,
    getEditorState,
    helpers,
    isMobile,
    t,
    experiments
  } = _a, rest = __objRest(_a, [
    __restKey(type),
    "setEditorState",
    "getEditorState",
    "helpers",
    "isMobile",
    "t",
    "experiments"
  ]);
  const toolbar = createToolbar({
    settings,
    setEditorState,
    getEditorState,
    helpers,
    isMobile,
    t,
    experiments
  });
  const keyBindingFn = (event, { getEditorState: getEditorState2 }) => {
    const editorState = getEditorState2();
    const currentBlock = getBlockAtStartOfSelection(editorState);
    const entityKey = currentBlock.getEntityAt(0);
    const entityType = entityKey && editorState.getCurrentContent().getEntity(entityKey).getType();
    if (entityType === LINK_PREVIEW_TYPE) {
      if (event.key === "Backspace") {
        return REMOVE_LINK_PREVIEW;
      }
    }
    return getDefaultKeyBinding(event);
  };
  const handleKeyCommand = (command, editorState, timestamp, { setEditorState: setEditorState2 }) => {
    if (command === REMOVE_LINK_PREVIEW) {
      const newState = convertLinkPreviewToLink(editorState);
      setEditorState2(newState);
      return "handled";
    }
    return "not-handled";
  };
  const basePluginProps = createBasePlugin(
    __spreadValues({
      component: LinkPreviewComponent,
      type,
      toolbar,
      settings,
      helpers,
      isMobile,
      t,
      getEditorState,
      setEditorState,
      defaultPluginData: DEFAULTS
    }, rest),
    { handleKeyCommand, keyBindingFn }
  );
  return basePluginProps;
};
createLinkPreviewPlugin.functionName = LINK_PREVIEW_TYPE;

export { createLinkPreviewPlugin };
//# sourceMappingURL=createLinkPreviewPlugin.js.map
